import { Typography } from '@mui/material'
import React from 'react'
import { ICourse } from '../../../interfaces/ICourse'
import { ISchool } from '../../../interfaces/school.interface'
import { formatAmount } from '../../../services/utils'

export default function CourseCardPriceComponent(props: {
  course: ICourse
  school?: Partial<ISchool>
}) {
  return (
    <>
      {Boolean(props.course.price) && (
        <Typography variant={'body2'} color={'primary'}>
          {props.school?.currency_symbol}
          {formatAmount(props.course.price)}
        </Typography>
      )}
      {!props.course.price && props.course.isPublic && (
        <Typography variant={'body2'} color={'primary'}>
          free
        </Typography>
      )}
      {!props.course.price && !props.course.isPublic && (
        <Typography variant={'body2'} color={'primary'}>
          private
        </Typography>
      )}
    </>
  )
}
